module.exports = __webpack_public_path__ + "img/razzo1.9c592f14.png";